import { Box, Divider, Flex, Image, Text } from '@chakra-ui/react';
import classNames from 'classnames';
import { Color } from 'presentation/theme/colorScheme';
import { FC, PropsWithChildren } from 'react';

export interface SidebarMenuItemProps extends PropsWithChildren {
  onClick: () => void;
  isLast: boolean;
  isFirst: boolean;
  text?: string | null;
  icon?: string | null;
  iconSize?: string | number;
  isActive: boolean;
  color?: string;
}

const SidebarMenuItem: FC<SidebarMenuItemProps> = ({
  onClick,
  children,
  isLast,
  isFirst,
  text,
  icon,
  iconSize = '30px',
  isActive,
  color,
}) => {
  return (
    <Box
      className={classNames('menuListItem', {
        menuListItem__selected: isActive,
      })}
      borderTopRadius={isFirst ? '16px' : '0'}
      borderBottomRadius={isLast ? '16px' : '0'}
      onClick={onClick}
      px="20px"
      bgColor={isActive ? Color.Shade200 : Color.Surface}
      _hover={{
        bgColor: Color.Shade200,
        cursor: 'pointer',
      }}
    >
      <Flex py="12px" alignItems="center">
        {icon && (
          <Image
            w={iconSize}
            h={iconSize}
            mr="12px"
            objectFit="contain"
            src={icon}
          />
        )}
        {children ?? (text && <Text fontWeight={600} color={color}>{text}</Text>)}
      </Flex>
      <Divider bgColor={!isLast ? Color.Shade100 : Color.Transparent} />
    </Box>
  );
};

export default SidebarMenuItem;
